/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WeekDayEnum } from './weekDayEnum';


export interface WorkingHoursApiModel { 
    id: number;
    intervalStart: string;
    intervalEnd: string;
    weekday: WeekDayEnum;
}
export namespace WorkingHoursApiModel {
}


